import React from 'react';
import './SNavigationButton.css';

export interface SNavigationButtonProps {
  leftIcon?: React.ReactNode;
  label: string;
  rightIcon?: React.ReactNode;
  subLabel?: string;
  rightValue?: string;
  onClick?: () => void;
  className?: string;
  active?: boolean;
  style?: React.CSSProperties;
}

export const SNavigationButton: React.FC<SNavigationButtonProps> = ({
  leftIcon,
  label,
  rightIcon,
  subLabel,
  rightValue,
  onClick,
  className = '',
  active = false,
  style,
}) => {
  return (
    <button
      className={`s-navigation-button ${className} ${active ? 'active' : ''}`}
      onClick={onClick}
      type="button"
      style={style}
    >
      <div className="s-navigation-button-left">
        {leftIcon && <div className="s-navigation-button-icon">{leftIcon}</div>}
        <div className="s-navigation-button-content">
          {subLabel && (
            <span className="s-navigation-button-sublabel">{subLabel}</span>
          )}
          <span className="s-navigation-button-label">{label}</span>
        </div>
      </div>
      <div className="s-navigation-button-right">
        {rightValue && (
          <span className="s-navigation-button-right-value">{rightValue}</span>
        )}
        {rightIcon && rightIcon}
      </div>
    </button>
  );
};

export default SNavigationButton;
